import PistonSection7 from './PistonSection7';
import PistonSection6 from './PistonSection6';
import PistonSection5 from './PistonSection5';
import PistonSection4 from './PistonSection4';
import PistonSection3 from './PistonSection3';
import PistonSection2 from './PistonSection2';
import PistonSection1 from './PistonSection1';

export default function Piston() {
  return (
    <>
      <PistonSection1 /> 
      <PistonSection2 />
      <PistonSection3 />  
      <PistonSection4 />  
      <PistonSection5 />
      <PistonSection6 />
    </>
  );
}
